<template>
  <v-content>
    <v-container @keyup.enter='login' class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-container>
                <v-toolbar-title>Learn NDT</v-toolbar-title>
              </v-container>
              <v-spacer />
            </v-toolbar>
            <v-container>
              <v-card-text>
                <v-alert dense outlined v-if="errors.length>0" type="error">{{ errors }}</v-alert>
                <v-form v-model="valid" ref="form">
                  <v-text-field
                    v-model="username"
                    :rules="usernameRules"
                    label="Username"
                    name="username"
                    prepend-icon="person"
                    type="text"
                  />
                  <v-text-field
                    v-model="password"
                    :rules="passwordRules"
                    label="Password"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                  />
                  <v-col class="text-right">
                    <v-btn class="mr-n5 primary--text" text @click="forgotPassword">Forgot password</v-btn>
                  </v-col>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" v-if='allowregistration' text @click="register">Register</v-btn>
                <v-spacer />
                <v-btn color="primary" @click="login">Login</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { LOGIN, FETCH_USER_REGISTRATION_STATUS, FETCH_LANGUAGES, FETCH_PAGES,CHECK_AUTH, RESET_STATE } from "@/store/actions.type"
import { SET_LOADING } from "@/store/mutations.type"
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import store from "@/store"
export default {
  name: "Login",
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_USER_REGISTRATION_STATUS, 'user').then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false);
      }
    });

    return next();
  },  
  data() {
    return {
      valid: false,
      username: "",
      usernameRules: [v => !!v || "Username is required"],
      password: "",
      passwordRules: [v => !!v || "Password is required"]
    };
  },
  methods: {
    login: function() {
      if (this.$refs.form.validate()) {
        let username = this.username;
        let password = this.password;
        this.$store
          .dispatch(LOGIN, { username, password })
          .then(async resp=> { 
            if(resp.success){
             await this.$store.dispatch(CHECK_AUTH).then( async userresp =>{
              if(userresp !== undefined && userresp.hasOwnProperty('success') && userresp.success ==true){
                 await this.$store.dispatch(FETCH_LANGUAGES, '').then(async resp =>{
                  if(resp.success){
                  await this.$store
                    .dispatch(FETCH_PAGES, "?lang_ids=" + userresp.data.user.company.language.lang_id).then(resp => {
                      if (resp.success) {
                        document.cookie ='company_domain='+location.host+'; domain='+ process.env.VUE_APP_ENV_DOMAIN +'; expires=Sun, 1 Jan 2023 00:00:00 UTC; path=/;'
                        this.$store.commit(SET_LOADING, false)
                        this.$router.push("/learningcenter")
                      }
                    });
                  }
                }) 
              }
             })
          } });
      }
    },
    forgotPassword(){
      this.$router.push("/forgot-password")
    },
    register(){
      this.$router.push("/register")
    },    
  },
  computed: {
    ...mapState({
      errors: state => state.auth.autherrors }),
    ...mapGetters([
      "allowregistration",
    ]),   
    isAuthenticated : function(){ return this.$store.getters.isAuthenticated}  
  },
  created(){
    if(this.isAuthenticated){
      this.$router.push("/learningcenter")
    }    
  }
};
</script>
